export default __webpack_public_path__ + "static/media/about_background.b79a7bcf.jpg";